<template>
  <div class="footer_box" v-if="isPC">
    <div class="content">
      <div class="target_list">
        <a :href="facebookUrl" target="_blank" class="icon facebook"></a>
        <a :href="instagramUrl" target="_blank" class="icon instagram"></a>
        <span class="icon wechat" @click="switchWechat"></span>
      </div>
      <div class="messages">
        <div class="title"></div>
        <div class="text_list">
          <p class="record" style="display: flex; align-items: center;justify-content: center;">
              <img src="@/assets/mobile/record.png" alt="record" style="width: 16px;"/>
              <span style="margin: 0 2px; color: #999;"></span> <!-- 分隔符 -->
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44180302000212" class="record" rel="noreferrer" target="_blank">粤公网安备44180302000212号</a>
              <span style="margin: 0 4px; color: #999;"></span> <!-- 分隔符 -->
              <a href="https://beian.miit.gov.cn" class="record" target="_blank">粤 ICP 备17051288号</a>
              <span style="margin: 0 8px; color: #999;">Copyright © 2018 EP Group</span> <!-- 分隔符 -->
          </p>
          <p class="record">Contact Us Tel:+86-763-6865858  Fax:+86-763-5858585</p>
        </div>
      </div>
      <div class="popup_wechat_code" :class="{show: wechatStatus}" v-if="wechatStatus">
        <!-- <div class="top_bar">
          <div class="icon_close"></div>
        </div> -->
        <div class="code_img" @click="switchWechat">
          <img src="@/assets/icon/wechat.png" alt="wechat code">
        </div>
      </div>
    </div>
  </div>
  <div class="mobile_footer_box" v-else>
    <div class="content">
      <div class="target_list">
        <a :href="facebookUrl" target="_blank" class="icon facebook"></a>
        <a :href="instagramUrl" target="_blank" class="icon instagram"></a>
        <span class="icon wechat" @click="switchWechat"></span>
      </div>
      <div class="messages">
        <div class="title"></div>
        <div class="text_list">
          <p class="record" style="display: flex; align-items: center;justify-content: center;"> 
            <img src="@/assets/mobile/record.png" alt="record" style="width: 16px;"/>
            <span style="margin: 0 2px; color: #999;"></span> <!-- 分隔符 -->
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44180302000212" class="record" target="_blank" style="margin-right:10px;">粤公网安备44180302000212号 </a>
            <span style="margin: 0 2px; color: #999;"></span> <!-- 分隔符 -->
            <a href="https://beian.miit.gov.cn" class="record" target="_blank"> 粤 ICP 备17051288号 - 2 </a> Copyright © 2018 EP Group
          </p>
          <p class="record">Contact Us Tel:+86-763-6865858  Fax:+86-763-5858585</p>
        </div>
      </div>
      <!-- wechat layer -->
      <div class="popup_box" @touchmove.prevent v-if="wechatStatus">
        <div class="content wechat_content">
          <div class="top_bar">
            <div class="m_icon_close" @click="switchWechat"></div>
          </div>
          <div class="code_img">
            <img src="@/assets/mobile/wechat.png" alt="wechat">
          </div>
          <div class="text_list">
            <p class="fonts">Scan it</p>
            <p class="fonts">pay attention to us.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'myFooter',
  data() {
    return {
      facebookUrl: 'https://www.facebook.com/EPfootwearGroup/',
      instagramUrl: 'https://www.instagram.com/epfootweargroup/',
      wechatStatus: false,
    }
  },
  computed: mapState({
     ...mapState(['isPC'])
  }),
  methods: {
    // 切换微信弹层状态
    switchWechat() {
      this.wechatStatus = !this.wechatStatus;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer_box{
  width: 100%;
  height: 84px;
  padding: 10px 0 20px;
  background-color: #fff;
  position: relative;
  .content{
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
  }
  .target_list{
    height: 24px;;
    position: relative;
    z-index: 2;
    .icon{
      display: block;
      width: 24px;
      height: 24px;
      overflow: hidden;
      float: left;
      margin-right: 33px;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      &.facebook{
      background-image: url(../../assets/icon/ep_18.png);
      background-size: 24px;
      }
      &.instagram{
        background-image: url(../../assets/icon/ep_20.png);
        background-size: 24px;
      }
      &.wechat{
        background-image: url(../../assets/icon/ep_22.png);
        background-size: 24px;
      }
    }
    &:last-child{
      margin-right: 0;
    }
  }
  .messages{
    width: 620px;
    overflow: hidden;
    position: absolute;
    top: 30px;
    left: 50%;
    margin-left: -320px;
    z-index: 1;
    .title{
      width: 100%;
      height: 22px;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../../assets/icon/title.png);
      background-size: 417px 22px;    
    }
    .text_list{
      width: 100%;
      text-align: center;
      padding-top: 12px;
      .record{
        line-height: 18px;
        font-size: 12px;
        color: #989898;
      }
    }
  }
  .popup_wechat_code{
    width: 160px;
    height: 160px;
    background-color: #fff;
    border: 1px solid #cdcdcd;
    overflow: hidden;
    position: absolute;
    left: 170px;
    top: -162px;
    z-index: 99;
    &.show{
      animation: myShow 1s ease;
    }
    .top_bar{
      width: 100%;
      height: 24px;
      overflow: hidden;
      .icon_close{
        width: 24px;
        height: 24px;
        float: right;
      }
    }
    .code_img{
      width: 160px;
      height: 160px;
      overflow: hidden;
      img{
        width: 100%;
      }
    }

  }
  @keyframes myShow {
    from { opacity: 0;  }
    to { opacity: 1; }
  }
}
.mobile_footer_box{
  width: 100%;
  padding: 0.25rem;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  .content{
    width: 100%;
  }
  .target_list{
    width: 2.5rem;
    height: 0.48rem;
    margin: 0 auto;
    overflow: hidden;
    .icon{
      display: block;
      width: 0.48rem;
      height: 0.48rem;
      overflow: hidden;
      float: left;
      margin-right: 0.53rem;
      background-position: center;
      background-repeat: no-repeat;
      &.facebook{
      background-image: url(../../assets/mobile/home_17.png);
      background-size: 0.48rem;
      }
      &.instagram{
        background-image: url(../../assets/mobile/home_19.png);
        background-size: 0.48rem;
      }
      &.wechat{
        background-image: url(../../assets/mobile/home_21.png);
        background-size: 0.48rem;
      }
    }
    .icon:last-child{
      margin-right: 0;
    }
  }
  .messages{
    width: 100%;
    margin-top: 0.15rem;
    overflow: hidden;
    .title{
      width: 100%;
      height: 0.2rem;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(../../assets/mobile/home_27.png);
      background-size: 4.2rem 0.2rem;    
    }
    .text_list{
      width: 100%;
      margin-top: 0.3rem;
      text-align: center;
      .record{
        line-height: 0.24rem;
        font-size: 0.18rem;
        color: #989898;
      }
    }
  }
  .wechat_content{
    width: 5.2rem;
    padding: 0.4rem 0.36rem;
    box-sizing: border-box;
    border: 1px solid #cdcdcd;
    overflow: hidden;
    .top_bar{
      width: 100%;
      height: 0.4rem;
      overflow: hidden;
      .m_icon_close{
        width: 0.4rem;
        height: 0.4rem;
        float: right;
      }
    }
    .code_img{
      width: 3.9rem;
      height: 3.8rem;
      margin: 0 auto;
      margin-top: 0.2rem;
      overflow: hidden;
      img{
        width: 100%;
      }
    }
    .text_list{
      width: 100%;
      font-size: 0.22rem;
      line-height: 0.3rem;
      padding-bottom: 0.2rem;
      color: #747474;
      text-align: center;
      overflow: hidden;
    }
  }
}
</style>
